import React, { FC } from 'react';
import { RequiredTabProps } from './RequiredTabProps';
import InformationCircle from '@ingka/ssr-icon/paths/information-circle';
import InlineMessage from '@ingka/inline-message';
import useTranslation from '../../hooks/useTranslation';
import { ESTABLISHMENT_TYPE } from '../ProjectTypeSelect/utils';
import NewUnitRequiredForm from './NewUnitRequiredForm';
import CloseRequiredForm from './CloseRequiredForm';
import RequiredForm from './RequiredForm';
import ImproveRequiredTab from '../ImproveRequiredTab';
import FormatChangeRequiredTab from '../FormatChangeRequiredTab';

const RequiredTab: FC<RequiredTabProps> = ({
  tabType,
  countries,
  isConfidentialAllowed,
  usersList,
  onCountryChange,
  onBUChange,
  BUList,
}) => {
  const t = useTranslation();
  return (
    <>
      <InlineMessage
        body={t('message.requiredMessage')}
        subtle={true}
        variant="informative"
        ssrIcon={InformationCircle}
      />
      {(() => {
        switch (tabType) {
          case ESTABLISHMENT_TYPE.NEW_UNIT:
            return (
              <NewUnitRequiredForm
                countries={countries}
                isConfidentialAllowed={isConfidentialAllowed}
                usersList={usersList}
                onCountryChanged={onCountryChange}
              />
            );
          case ESTABLISHMENT_TYPE.CLOSE:
            return (
              <CloseRequiredForm
                countries={countries}
                isConfidentialAllowed={isConfidentialAllowed}
                BUList={BUList}
                onCountryChange={onCountryChange}
                usersList={usersList}
                onBUChange={onBUChange}
              />
            );
          case ESTABLISHMENT_TYPE.IMPROVE:
            return (
              <ImproveRequiredTab
                BUList={BUList}
                countries={countries}
                isConfidentialAllowed={isConfidentialAllowed}
                usersList={usersList}
                onCountryChanged={onCountryChange}
                onBUChange={onBUChange}
              />
            );
          case ESTABLISHMENT_TYPE.FORMAT_CHANGE:
            return (
              <FormatChangeRequiredTab
                BUList={BUList}
                countries={countries}
                isConfidentialAllowed={isConfidentialAllowed}
                usersList={usersList}
                onCountryChanged={onCountryChange}
                onBUChange={onBUChange}
              />
            );
          case ESTABLISHMENT_TYPE.RELOCATION:
            return (
              <RequiredForm
                BUList={BUList}
                countries={countries}
                userList={usersList}
                isConfidentialAllowed={isConfidentialAllowed}
                onCountryChange={onCountryChange}
                onBUChange={onBUChange}
              />
            );
        }
      })()}
    </>
  );
};

export default RequiredTab;
